(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/components/login.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/components/login.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Form = svs.ui.reactForm.Form;
const TextInput = svs.ui.reactFormInputs.TextInput;
const Button = svs.ui.ReactButton;
const Login = () => {
  const _svs$grassroots_partn = svs.grassroots_partner.useLogin(svs),
    onLoginHandler = _svs$grassroots_partn.onLoginHandler;
  const _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    userName = _React$useState2[0],
    setUserName = _React$useState2[1];
  const _React$useState3 = React.useState(''),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    password = _React$useState4[0],
    setPassword = _React$useState4[1];
  return React.createElement("div", {
    className: "grid-row padding-2 login"
  }, React.createElement("div", {
    className: "col-xs-12 col-md-4 col-md-offset-4 f-content"
  }, React.createElement("h2", {
    className: "padding-bottom-1 align-center"
  }, "Gr\xE4sroten partner inloggning"), React.createElement(Form, {
    isVertical: true,
    onSubmit: onLoginHandler
  }, React.createElement("div", {
    className: "control-group padding-xs-bottom-2 padding-lg-bottom-3"
  }, React.createElement(TextInput, {
    errorMessageRequired: "Anv\xE4ndarnamn m\xE5ste anges",
    label: "Anv\xE4ndarnamn",
    name: "userName",
    onChange: e => setUserName(e.target.value),
    type: "text",
    value: userName
  }), React.createElement(TextInput, {
    errorMessageRequired: "L\xF6senord m\xE5ste anges",
    isRequired: true,
    label: "L\xF6senord",
    name: "password",
    onChange: e => setPassword(e.target.value),
    type: "password",
    value: password
  }), React.createElement(Button, {
    block: true,
    className: "margin-xs-top-3",
    focus: true,
    size: 300,
    type: "submit"
  }, "Logga in")))));
};
svs.grassroots_partner.Login = Login;

 })(window);